"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fallBackEnvs = void 0;
/**
 * Auto-generated by rewriteFallbackEnvs.sh
 */
exports.fallBackEnvs = {
    AWS_DEFAULT_REGION: 'ap-southeast-2',
    accountId: '155987728800',
    projectCode: 'v0202',
    projectName: 'v020-2',
    stage: 'test',
    AWS_PROFILE: 'v020-2-test',
};
